<template>
  <div v-if="currentPrice > -1" class="kj-pro-now_price">
    <img v-if="currentPriceAvatar" :src="currentPriceAvatar" class="kj-pro-now_price_avator">
    <span class="kj-pro-now_price_cont">当前价格 ￥{{(currentPrice/100).toFixed(2)}}</span>
  </div>
</template>
<script>
  export default {
    props: {
      currentPrice: {
        default: -1
      },
      currentPriceAvatar: {
        default: ''
      }
    }
  }
</script>

<style scoped>
.kj-pro-now_price {
  display: block;
  margin: auto;
  padding: 6px;
  background-color: rgba(255, 255, 255, .8);
  border-radius: 9px;
  color: #000;
  font-size: 0;
  line-height: 0;
  text-align: center;
  box-shadow: 0 7px 10px 0 #4a36e0;
}
.kj-pro-now_price_avator {
  display: inline-block;
  margin: 0 4px 0 0;
  width: 25px;
  height: 25px;
  border-radius: 3px;
  vertical-align: middle;
  object-fit: cover;
}
.kj-pro-now_price_cont {
  display: inline-block;
  margin: 0 3px;
  font-size: 14px;
  color: #333;
  vertical-align: middle;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// currentPrice.vue?2d19fb76